import axios from '@axios'

export const state = {
  tickets: [],
  ticket: {},
  currentPage: 1,
  perPage: 15,
  totalPage: 1,
  totalRecord: 0,
}

export const getters = {
  allTickets: (state) => state.tickets,
  ticketAndReplies: (state) => state.ticket,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPage: (state) => state.totalPage,
  totalRecord: (state) => state.totalRecord,
}

export const mutations = {
  CLEAR_TICKET_STATE: (state) => {
    state.tickets = []
    state.currentPage = 1
    state.perPage = 15
    state.totalPage = 1
    state.totalRecord = 0
  },
  CLEAR_TICKET_REPLY_STATE: (state) => {
    state.ticket = {}
  },
  GET_TICKETS: (state, resp) => {
    if (!resp) return null
    state.tickets = resp.tickets
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPage = resp.totalPages
    state.totalRecord = resp.totalRecords
  },
  GET_TICKET: (state, resp) => {
    if (!resp) return null
    state.ticket = resp
  },
  CREATE_REPLY: (state, resp) => {
    if (!resp) return null
    state.ticket.replies.unshift(resp)
  },
  CREATE_TICKET: (state, resp) => {
    if (!resp) return null
    state.tickets.unshift(resp)
  },
  REMOVE_REPLY: (state, ticket) => {
    if (!ticket) return null
    state.ticket.replies = state.ticket.replies.filter(
      (item) => item.id !== ticket.id
    )
  },
}

export const actions = {
  async getTickets({ commit }) {
    commit('CLEAR_TICKET_STATE')
    await axios
      .get(`/api/tickets`)
      .then((resp) => {
        if (resp.status === 200) {
          commit('CLEAR_TICKET_STATE')
          let data = Object.assign({}, resp.data)
          commit('GET_TICKETS', data)
        }
      })
      .catch(() => {
        commit('GET_TICKETS', null)
      })
  },
  async getTicketById({ commit }, ticketId) {
    commit('CLEAR_TICKET_REPLY_STATE')
    await axios
      .get(`/api/tickets/${ticketId}/replies`)
      .then((resp) => {
        if (resp.status === 200) {
          let data = Object.assign({}, resp.data)
          commit('GET_TICKET', data)
        }
      })
      .catch(() => {
        commit('GET_TICKET', null)
      })
  },
  async createTicket({ commit }, payload) {
    await axios
      .post(`/api/tickets`, payload)
      .then((resp) => {
        if (resp.status === 201) {
          let data = Object.assign({}, resp.data)
          commit('CREATE_TICKET', data)
        }
      })
      .catch(() => {
        commit('CREATE_TICKET', null)
      })
  },

  async createReply({ commit }, payload) {
    await axios
      .post(`/api/tickets/${payload.ticketId}/replies`, payload.form)
      .then((resp) => {
        if (resp.status === 201) {
          let data = Object.assign({}, resp.data)
          commit('CREATE_REPLY', data)
        }
      })
      .catch(() => {
        commit('CREATE_REPLY', null)
      })
  },
  async deleteReply({ commit }, form) {
    await axios
      .delete(`/api/tickets/replies`, { data: form })
      .then((resp) => {
        if (resp.status === 204) {
          commit('REMOVE_REPLY', form)
        }
      })
      .catch(() => {
        commit('REMOVE_REPLY', null)
      })
  },
}
